import { motion } from "framer-motion";
import { ColorRing } from "react-loader-spinner";
export default function AppLoading({ loading }) {
  // TODO Make these hooks consistent

  return (
    <div
      style={{ width: "100vw", height: "100vh" }}
      className="bg-whitetext-center flex items-center content-center justify-center"
    >
      <motion.div
        style={{ scale: 0, opacity: 0 }}
        transition={{
          type: "spring",
          stiffness: 16,
          duration: 800,
          damping: 8,
        }}
        animate={{ scale: 1, opacity: 1 }}
      >
        <div
          className="bg-gray-300 bg-opacity-80 rounded-lg flex items-center"
          style={{ width: 242 * 0.7, height: 100 * 0.7 }}
        >
          <div className="mx-auto">
            <ColorRing
              visible={true}
              height="38"
              width="38"
              ariaLabel="blocks-loading"
              colors={["#FFF", "#FFF", "#FFF", "#FFF", "#FFF"]}
            />
          </div>
        </div>
      </motion.div>
    </div>
  );
}
